import RPDealerStartWindow from 'components/RpDealerStartWindow'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Container } from '../styles'
import { useRussianPokerStore } from '../useRussianPokerStore'
import GamePlay from './GamePlay'

const RpContainer: FC = observer(() => {
  const { game } = useRussianPokerStore()

  return <Container>{!game ? <RPDealerStartWindow /> : <GamePlay />}</Container>
})

export default RpContainer
